import Transformer from './Transformer'
import HorseTransformer from './HorseTransformer'
import ActesDocumentLienTransformer from './ActesDocumentLienTransformer'

import _orderBy from 'lodash/orderBy'
import _defaults from 'lodash/defaults'

/**
 * Retourne une liste de
 * @param {Dexie.Collection} documents
 */
export class DocumentLienTransformer extends Transformer {

	table = 'horse_document_lien'
	transactionTables = ['horse', 'horse_document']

	async horse(lien) {
		const horse = await this.fetchRelationship(lien, 'documentlien_horse')
		return HorseTransformer.process(horse, 'withPedigree')
	}

	async document(lien) {
		const document = await this.fetchRelationship(lien, 'documentlien_document')
		if(!document) {
			return {
				document_id: 0,
				document_name: '',
				document_filename: '',
				document_date: new Date()
			}
		}
		const document_acte = await this.db().t('actes_document_lien')
		.then(table => {
			return table.where('actesdocumentlien_document').equals(document.document_id).toArray()
		})
		
		document.actesdocumentlien_actes = document_acte.length > 0 ? document_acte[0].actesdocumentlien_actes : null
		
		return document
	}

	async fetch(col) {
		this.additionalColumns({
			horse: this.horse,
			document: this.document
		})

		return col
	}

	async transform(lien) {
		return {
			'documentlien_id': lien.documentlien_id,
			'documentlien_horse': lien.documentlien_horse,
			'document_id': lien.document ? lien.document.document_id : null,
			'document_name': lien.document ? lien.document.document_name : null,
			'document_filename': lien.document ? lien.document.document_filename : null,
			'document_date': lien.document ? lien.document.document_date : null,
			'actesdocumentlien_actes': lien.document ? lien.document.actesdocumentlien_actes : null,
			'horse': lien.horse
		}
	}
}

export default DocumentLienTransformer
